import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Close from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Email from "@material-ui/icons/Email";

// styles
import styles from "./styles";

class User extends Component {
  static propTypes = {
    classes: PropTypes.object,
    user: PropTypes.object,
    deleteOrganizationUser: PropTypes.func,
    refresh: PropTypes.func,
  };

  async deleteOrganizationUser() {
    const { deleteOrganizationUser, user, refresh } = this.props;
    await deleteOrganizationUser(user.relationID);
    refresh();
  }

  render() {
    const { classes, user } = this.props;

    return (
      <div className={!user.pending ? classes.container : classes.pending}>
        <Close
          style={{
            position: "absolute",
            top: 4,
            right: 4,
            cursor: "pointer",
            height: 15,
            zIndex: 999,
          }}
          onClick={this.deleteOrganizationUser.bind(this)}
        />
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <Avatar>
              {user.active ? (
                `${user.firstName[0]}${user.lastName[0]}`
              ) : (
                <Email />
              )}
            </Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography style={{ width: 220, overflowWrap: "break-word" }}>
              {user.firstName} {user.lastName}
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              style={{ width: 220, overflowWrap: "break-word" }}
            >
              {user.email}
            </Typography>
            {user.pending ? (
              <Typography style={{ color: "#e91e63" }}>Invited</Typography>
            ) : (
              []
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(User);
